import { type MCPServerInfo } from '../../types';

const BoxServer: MCPServerInfo = {
  serverId: 'BOX',
  name: 'Box',
  slug: 'box',
  description: 'Box MCP Server (Remote))',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.box.com'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default BoxServer;
